
import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface ArticleFormErrorProps {
  error: string;
  onCancel: () => void;
}

const ArticleFormError = ({ error, onCancel }: ArticleFormErrorProps) => {
  return (
    <div className="p-8">
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{error}</AlertDescription>
      </Alert>
      <Button onClick={onCancel}>Back to Articles</Button>
    </div>
  );
};

export default ArticleFormError;
